import React, { Component, Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import {
  Typography,
  CircularProgress,
  Divider,
  Select,
  TextField,
  InputAdornment,
  Menu,
  MenuItem,
} from '@material-ui/core'
import DonutChart from '../charts/DonutChart'
import Cookies from 'js-cookie'
import roiStandIn from '../../assets/homeStandIns/roiStandIn.png'
import moment from 'moment'
import {BiCaretUp, BiCaretDown} from 'react-icons/bi'
import AskReport from '../AskReport'

// const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm"
const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/"

const StyledTextField = styled(TextField)({
  '& label': {
    color: '#fff',
  },
  '& label.Mui-focused': {
    color: '#18bdfe',
  },
  '& .MuiOutlinedInput-root': {
    color: '#fff',
    borderRadius: "8px",
    '&:hover fieldset': {
      borderColor: '#18bdfe',
    },
    '& fieldset': {
      color: '#fff',
      borderColor: '#fff'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#18bdfe',
      color: '#fff',
    },
  },
  '& .MuiOutlinedInput-input': {
    color: '#fff',
    backgroundColor: 'transparent',
    borderRadius: 4,
  }
})

const StyledTextFieldLT = styled(TextField)({
  '& label': {
    color: '#3d3d3d',
  },
  '& label.Mui-focused': {
    color: '#18bdfe',
  },
  '& .MuiOutlinedInput-root': {
    color: '#3d3d3d',
    borderRadius: "8px",
    '&:hover fieldset': {
      borderColor: '#18bdfe',
    },
    '& fieldset': {
      color: '#3d3d3d',
      borderColor: '#3d3d3d'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#18bdfe',
      color: '#3d3d3d',
    },
  },
  '& .MuiOutlinedInput-input': {
    color: '#3d3d3d',
    backgroundColor: 'transparent',
    borderRadius: 4,
  }
})

export default function BoomModule(props) {
  const {darkMode} = props
  const token = Cookies.get("token")
  const start = moment().subtract(12, "months")  
  const corpID = JSON.parse(localStorage.getItem("currentUser")) ? JSON.parse(localStorage.getItem("currentUser"))[0].corpID : 0
  const completed = [315, 173]
  const [boomRoi, setBoomRoi] = useState(null)
  const [custprosRoi, setCustprosRoi] = useState(null)
  const [option, setOption] = useState("Sales")
  const [anchor, setAnchor] = useState(null)


  const getBoomRoi = () => {
    let completeParam = completed.includes(corpID) ? 1 : 0
    console.log("DEBUG", base_url)

    const request = Promise.all([
      fetch(`${base_url}/boomROI?startDate=${start.format("YYYY-MM-DD")}&endDate=${moment().format("YYYY-MM-DD")}&complete=${completeParam}`, {
        headers: {token: token}
      }),
      fetch(`${base_url}/boomROI/custPros?startDate=${start.format("YYYY-MM-DD")}&endDate=${moment().format("YYYY-MM-DD")}&complete=${completeParam}`, {
        headers: {token: token}
      }),
  ])

    request.then(([response, response2]) => Promise.all([response.json(), response2.json()]))
    .then(([data, data2]) => {
      // console.log(data2)
      if(data || data2) {
        setBoomRoi(data[0].Data[0])
        setCustprosRoi(data2)
      }
      else {
        setBoomRoi([])
        setCustprosRoi([])
      }
    })
    .catch(error => console.log(error))
  }

  useEffect(() => getBoomRoi(), [])

  const openMenu = (e) => {
    const { currentTarget } = e

    setAnchor(currentTarget)
  }

  const handleMenuClose = () => {
    setAnchor(null)
  }

  const handleOptionSelect = (value) => {
    setOption(value)
    setAnchor(null)
  }

  if(!custprosRoi) return <CircularProgress className="home-page-loader" />
  if(boomRoi.length < 1 || custprosRoi.length < 1) return <AskReport home={true}/>  

  // console.log(boomRoi.length)
  console.log(custprosRoi)

  return(
    <div className="boom-root">
      {console.log(darkMode)}
      <Typography style={{fontSize: '12px', color: `${darkMode ? "#fff" : "#3d3d3d"}`}} align="center">
        On completed promotions, a total spend of <span className="spend">${Math.round(boomRoi.Cost).toLocaleString('en')}</span> has yielded <span style={{color: 'rgba(113, 177, 40)', fontWeight:'bold'}}>${Math.round(boomRoi.Sales).toLocaleString('en')}</span> in sales to responders (at a {(boomRoi.Res_Rate * 100).toFixed(2)}% response rate)
      </Typography>
      <div className="boom-home">
        <div className={darkMode ? "boom-stats-home boom-home-dk" : "boom-stats-home boom-home-lt"}>
          <div>
            <h5 style={{color: '#00c2bb'}}>AVG TICKET</h5>
            <span style={{fontSize: "15px", fontWeight: "bold"}}>${Math.round(boomRoi.Sales / boomRoi.Responses).toLocaleString('en')}</span>
          </div>
          <Divider className="divider"/>
          <div>
            <h5 style={{color: '#61b304'}}>INC SALES</h5>
            <span style={{fontSize: "15px", fontWeight: "bold"}}>${Math.round(boomRoi.ADJ_Sales).toLocaleString('en')}</span>
          </div>
          <Divider className="divider"/>
          <div >
            <h5 style={{color: '#faa2f4'}}>INC RESPONSES</h5>
            <span style={{fontSize: "15px", fontWeight: "bold"}}>{Math.round(boomRoi.ADJ_Resp).toLocaleString('en')}</span>
          </div>
        </div>
        <div className="chart">
          {darkMode ?
            <StyledTextField
              variant="outlined"
              size="small"
              className="select"
              value={option}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <BiCaretDown />
                  </InputAdornment>
                )
              }}
              onClick={openMenu}
            />
          :
            <StyledTextFieldLT
              variant="outlined"
              size="small"
              className="select"
              value={option}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <BiCaretDown />
                  </InputAdornment>
                )
              }}
              onClick={openMenu}
            />
          }

          <Menu
            open={Boolean(anchor)}
            anchorEl={anchor}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={() => handleOptionSelect("Sales")} value={"Sales"}><Typography variant="caption">Sales</Typography></MenuItem>
            <MenuItem onClick={() => handleOptionSelect("Mailed")} value={"Mailed"}><Typography variant="caption">Mailed</Typography></MenuItem>
            <MenuItem onClick={() => handleOptionSelect("Responses")} value={"Responses"}><Typography variant="caption">Responses</Typography></MenuItem>
          </Menu>
          <br/>
          <DonutChart
            labels={['Customer', 'Prospect']}
            // data={[Math.round(boomRoi.Cost), Math.round(boomRoi.ADJ_Sales)]}
            data={custprosRoi.map(item => Math.round(item[option]))}
            // colors={["rgba(163, 219, 255, 0.8)", "rgba(255, 237, 117)"]}
            colors={darkMode ? ["#a3dbff", "#ffed75"] : ["#1fa7ff", "#d9a300"]}
            radius={'70%'}
            labelShow={true}
            legend={true}
            position={'top'}
            height={250}
            darkMode={darkMode}
          />
        </div>
      </div>
      {/* <Select
        className="boom-select"
      >

      </Select> */}
      {/* {this.state.isLoading ? <div className={classes.loader}><CircularProgress /></div> :
        Object.keys(this.state.boomRoi).length > 0 ?
        <Fragment>
            <div className={classes.pie}>
            </div>
          </div>
        </Fragment>
        : <div style={{textAlign: 'center', position: 'relative'}}>
            <div className={classes.unavailable}>
              <Typography style={{fontSize: '17px', color: '#0c5ab4', fontWeight: 'bold'}}>COMING SOON</Typography>
              <Typography variant="caption">This screen is unavailable at this time. For more information please contact Support at <a href="mailto:support@lsdirect.com">support@lsdirect.com</a></Typography>
            </div>
            <img className={classes.standIn} src={roiStandIn} alt=""/>
          </div>
      } */}
    </div>
  )
}

//
// import moment from 'moment'
//
// const today = moment().format('YYYY-MM-DD')
// const twelveMonthsPast = moment().subtract(12, 'months').format('YYYY-MM-DD')
//
// const styles = theme => ({
//   root: {
//     width: '100%'
//   },
//   loader: {
//     marginLeft: '45%',
//     marginTop: '30%',
//   },
//   data: {
//     display: 'flex',
//     textAlign: 'center',
//     justifyContent: 'space-evenly'
//   },
//   stats: {
//     fontWeight: 'bold',
//     color: '#fff',
//     // color: '#626262',
//     [theme.breakpoints.up('xl')]: {
//       fontSize: 16
//     }
//   },
//   statsDark: {
//     fontWeight: 'bold',
//     color: '#fff',
//     [theme.breakpoints.up('xl')]: {
//       fontSize: 16
//     }
//   },
//   pie: {
//     paddingTop: 40,
//   },
//   divider: {
//     opacity: 0.4,
//   },
//   customWidth: {
//     maxWidth: 500,
//   },
//   standIn: {
//     width: '100%',
//     [theme.breakpoints.up('xl')]: {
//       marginTop: '-50px',
//       height: '35%',
//       width: '85%'
//     },
//     [theme.breakpoints.down('lg')]: {
//       width: '120%',
//       marginTop: '-35px'
//     }
//   },
//   unavailable: {
//     position: 'absolute',
//     textAlign: 'center',
//     marginTop: '100px'
//   }
// })
//
// class BoomModule extends Component {
//   _isMounted = false
//
//   constructor(props) {
//     super(props)
//     this.state = {
//       isLoading: true,
//       boomRoi: {},
//       completed: JSON.parse(localStorage.getItem('currentUser'))[0].compIDs === '315' ? 0 : 1
//     }
//   }
//
//   componentDidMount() {
//     this._isMounted = true
//
//     fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/boomROI?startDate=${twelveMonthsPast}&endDate=${today}&complete=${this.state.completed}`,{
//       method: 'GET',
//       headers: {
//         'token': Cookies.get('token')
//       },
//     })
//     .then(response => response.json())
//     .then(data => {
//       if(this._isMounted && data) {
//         this.setState({
//           isLoading: false,
//           boomRoi: data[0].Data[0],
//         })
//       } else {
//         this.setState({
//           isLoading: false,
//           boomRoi: {}
//         })
//       }
//     })
//     .catch(error => {
//       console.log(error)
//     })
//   }
//
//   componentWillUnmount() {
//     this._isMounted = false
//   }
//
//   render() {
//     const { classes } = this.props
//
//     return(
//       <div className={classes.root}>
//         {this.state.isLoading ? <div className={classes.loader}><CircularProgress /></div> :
//           Object.keys(this.state.boomRoi).length > 0 ?
//           <Fragment>
//             <Typography style={{fontSize: '12px', color: '#fff'}} align="center">
//               On completed promotions, a total spend of <span style={this.props.darkMode ? {color: 'rgba(255, 115, 115, 0.7)'} : {color: 'rgba(255, 0, 0, 0.7)'}}>${Math.round(this.state.boomRoi.Cost).toLocaleString('en')}</span> has yielded <span style={{color: 'rgba(113, 177, 40)', fontWeight:'bold'}}>${Math.round(this.state.boomRoi.Sales).toLocaleString('en')}</span> in sales to responders (at a {(this.state.boomRoi.Res_Rate * 100).toFixed(2)}% response rate)
//             </Typography>
//             <div className={classes.data}>
//               <div style={{ display: 'block', textAlign: 'left', marginLeft: '20px'}}>
//                 <div>
//                   <h5 style={{opacity: 0.8, color: '#00c2bb'}}>AVG TICKET</h5>
//                   <span className={this.props.darkMode ? classes.statsDark : classes.stats}>${Math.round(this.state.boomRoi.Sales / this.state.boomRoi.Responses).toLocaleString('en')}</span>
//                 </div>
//                 <hr className={classes.divider}/>
//                 <div>
//                   <h5 style={{opacity: 1.0, color: '#61b304'}}>INC SALES</h5>
//                   <span className={this.props.darkMode ? classes.statsDark : classes.stats}>${Math.round(this.state.boomRoi.ADJ_Sales).toLocaleString('en')}</span>
//                 </div>
//                 <hr className={classes.divider}/>
//                 <div >
//                   <h5 style={this.props.darkMode ? {opacity: 0.8, color: '#faa2f4'} : {opacity: 0.8, color: '#faa2f4'}}>INC RESPONSES</h5>
//                   <span className={this.props.darkMode ? classes.statsDark : classes.stats}>{Math.round(this.state.boomRoi.ADJ_Resp).toLocaleString('en')}</span>
//                 </div>
//               </div>
//               <div className={classes.pie}>
//                 <DonutChart
//                   labels={['Total Spend', 'Incremental Sales']}
//                   data={[Math.round(this.state.boomRoi.Cost), Math.round(this.state.boomRoi.ADJ_Sales)]}
//                   colors={['rgba(235, 82, 82, 0.9)', 'rgba(110, 209, 0, 0.9)']}
//                   radius={'85%'}
//                   labelShow={true}
//                   legend={true}
//                   position={'bottom'}
//                   height={250}
//                   darkMode={true}
//                 />
//               </div>
//             </div>
//           </Fragment>
//           : <div style={{textAlign: 'center', position: 'relative'}}>
//               <div className={classes.unavailable}>
//                 <Typography style={{fontSize: '17px', color: '#0c5ab4', fontWeight: 'bold'}}>COMING SOON</Typography>
//                 <Typography variant="caption">This screen is unavailable at this time. For more information please contact Support at <a href="mailto:support@lsdirect.com">support@lsdirect.com</a></Typography>
//               </div>
//               <img className={classes.standIn} src={roiStandIn} alt=""/>
//             </div>
//         }
//       </div>
//     )
//   }
// }
//
// export default withStyles(styles)(BoomModule)
